import { render } from "./FirstTimerSettings.vue?vue&type=template&id=570b6ba6&scoped=true"
import script from "./FirstTimerSettings.vue?vue&type=script&lang=js"
export * from "./FirstTimerSettings.vue?vue&type=script&lang=js"

import "./FirstTimerSettings.vue?vue&type=style&index=0&id=570b6ba6&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-570b6ba6"]])

export default __exports__